module.exports = __webpack_public_path__ + "img/download-assessment-icon.6ef00048.svg";